import { useEffect, useState } from 'react';
import { useRootStore } from './useRootStore';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

export interface GoogleSheetExistsResult {
    isLoaded: boolean
    spreadSheetExists: boolean,
    sheetExists: boolean
}

export const useGoogleSheetExists = () => {
    const rootStore = useRootStore();
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<GoogleSheetExistsResult>({
        isLoaded: false,
        spreadSheetExists: false,
        sheetExists: false
    });

    useEffect(() => {
        const kindVersion = rootStore.kindVersionStore.currentKindVersion;

        if (kindVersion != null) {
            setResult({ isLoaded: false, spreadSheetExists: false, sheetExists: false });

            if (kindVersion.kind.googleSheetId == null)
                setResult({ isLoaded: true, spreadSheetExists: false, sheetExists: false });
            else {
                rootStore.kindVersionStore.sheetExists(kindVersion, rootStore.gameEnvironmentsStore.getCurrentGameEnvironment())
                    .then(sheetExists => {
                        setResult({ isLoaded: true, spreadSheetExists: true, sheetExists: sheetExists });
                    })
                    .catch((e: any) => {
                        publishNotification({
                            text: `Error loading google sheet status: ${e.message}`,
                            canClose: true
                        });
                    });
            }
        }
    }, [rootStore.kindVersionStore, rootStore.gameEnvironmentsStore, publishNotification, rootStore.gameEnvironmentsStore.currentGameEnvironment, rootStore.kindVersionStore.currentKindVersion, rootStore.kindVersionStore.currentKindVersion?.kind]);

    return result;
};
